import { styled } from '@linaria/react'

/** An authored (None-section) field in its own white box on the grey section, with its Edit in the corner. */
export const AuthoredFieldBox = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  padding: 0.875rem 1rem;
  border: 1px solid var(--neutral-150, #d8dee4);
  border-radius: 0.5rem;
  background-color: white;
  box-shadow: 0 1px 3px rgba(18, 43, 51, 0.08);
`

/** Row holding a preview's Edit + Delete links, aligned to the bottom-right of the field box. */
export const FieldActionsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  column-gap: 0.75rem;
`

/** A selected radio — coloured ring with a filled centre, for the default-selected option in a preview. */
export const PreviewRadioMarkChecked = styled.span`
  position: relative;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1px solid var(--intent-primary, #5a37d6);
  background-color: white;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background-color: var(--intent-primary, #5a37d6);
  }
`

/** An unchecked checkbox mark for a CheckboxGroup option preview - square, unlike PreviewRadioMark's circle.
 * No checked variant: unlike RadioGroup, a CheckboxGroup has no "Default selection" concept to highlight. */
export const PreviewCheckboxMark = styled.span`
  width: 1rem;
  height: 1rem;
  border-radius: 0.25rem;
  border: 1px solid var(--neutral-200, #c3ccd5);
  flex-shrink: 0;
`
